import React from 'react';
import ImpressionSubTable from '../ImpressionsTimeLine';

// =============================================================================
// SignupImpressionsView (V1 simplified-report path) — thin adapter that
// hands the loader-fetched impressions array off to the (now facelifted)
// `<ImpressionSubTable/>` adapter, which in turn renders the shared
// `<ImpressionTimeline/>` primitive. Empty / loading state is owned by the
// primitive — this view no longer needs its own AntD `<Empty/>` wrapper.
// =============================================================================

const SignupImpressionsView = ({ impressions }) => (
  <ImpressionSubTable impressions={impressions || []} />
);

export default SignupImpressionsView;
